import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import Switch from "@material-ui/core/Switch";
// import ManageTemplate from './manage_crf';
import { makeStyles, Select, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import StatusDot from "../../Components/status_dot";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { useHistory } from "react-router-dom";
import ProgressBox from "./../Roles/Organization/ManageInfo/filter_card";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import SearchByCategory from "../../Components/category_based_search";
import ViewSummary from "./../Roles/Organization/ManageInfo/view_summary";
import { Box } from "@material-ui/core";
import AssigmentFilterModal from "../Roles/Organization/ManageInfo/AssigmentFilterModal";
import moment from "moment";
import User from "../../Images/User.png";
import { DateRange } from "react-date-range";
import MIFeedbackModal from "../Roles/Organization/ManageInfo/MIFeedbackModal";
//import FilterListIcon from '../../../../Images/filtericon.png';
import FilterListIcon from "@material-ui/icons/FilterList";
import { Filter } from "@material-ui/icons";
import StatisticsSummaryDrawer from "./StatisticsSummaryDrawer";
import DataService from "../../Service";
import HomeHeaderMenu from "./HomeHeaderMenu";
import { TooltipWrapper } from "../../Common/Utils/common_utils";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    PaddingTop: "2%",
  },
  actionButtons: {
    marginTop: "-3%",
    textAlign: "center",
    /* padding-left: 239px; */
    paddingLeft: "25px",
  },
  tableWrapper: {
    width: "95%",
    paddingLeft: "2%",
    margin: "2% 3%",
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    width: "85%",
  },
  bodyContainer: {
    maxWidth: "92%",
    flexGrow: 1,
    margin: "0 auto",
    marginTop: "20px",
  },
  bodyContainer1: {
    maxWidth: "90%",
    margin: "0 auto",
    marginTop: "20px",
  },
  row: {
    "& button": {
      display: "none",
    },
    "&:hover": {
      "& button": {
        display: "inline-block",
      },
    },
  },
  searchCategory: {
    marginLeft: "25rem",
    marginRight: "1rem",
    width: "504px",
    "& div": {
      "& .MuiInputBase-root": {
        "& div": {
          paddingTop: "17px",
        },
        "& input": {
          paddingTop: "16px",
        },
      },
    },
  },

  textSecondary: {
    color: theme.palette.secondary.main,
  },
  datePicker: {},
  datepickerPopover: {
    textAlign: "right",
    marginBottom: "33px",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },
  miTable: {
    "& .MuiToolbar-root": {
      "& .material-icons": {
        color: theme.palette.secondary.main,
      },
    },
    "& .MuiTableBody-root": {
      "& .MuiTableCell-body": {
        padding: "10px 16px",
        lineHeight: "1.50",
        "& .MuiIconButton-root": {
          padding: "0px 16px",
        },
      },
    },
  },
}));

const rawData = [];
const ITEM_HEIGHT = 48;
const options1 = ["View summary", "View details"];
function FilterMI() {
  const classes = useStyles();

  const [currentSelection, setCurrentSelection] = useState({});
  const [hiddenCol, setHiddenCol] = useState(false);
  const [action, setAction] = useState("");
  const [modules, setModules] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(100);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [viewAction, setViewAction] = useState(null);
  const [dropDownOption, setDropDownOption] = useState(null);
  const [anchorPopover, setAnchorPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchCategory, setSearchCategory] = useState({});
  const [assignmentData, setAssignmentData] = useState([]);
  const [data, setData] = useState(rawData);
  const [filterModal, setFilterModal] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [serviceTypeList, setServiceTypeList] = useState([
    { id: 1, name: "internal", value: "Internal" },
    { id: 2, name: "external", value: "External" },
  ]);
  const [dropDownValue, setDropDownValue] = useState(null);
  const [drawerFilterValue, setDrawerFilterValue] = useState(null);
  const [organizationLoader, setOrganizationLoader] = useState(false);
  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [filterStatisticsValue, setFilterStatisticsValue] = useState("");
  const [isFeedback, setIsFeedback] = useState(false);
  // This is the only downside.. very hacky
  const [, setForceUpdate] = useState(0);
  const open = Boolean(anchorEl);
  // const themeColor =
  //   sessionStorage.getItem("role") == "admin" ? "#3B86FF" : "#981B1E";

  const globaluserData = useSelector(state=>state.commonReducer)
  console.log("global user dra", globaluserData.role);
  let role = globaluserData?.role;
  let organisationId = globaluserData?.organisation_id
  // let role = sessionStorage.getItem("role");  //admin
  // let organisationId = sessionStorage.getItem("organisation_id"); //undefined

  const forceUpdate = () => setForceUpdate((old) => old + 1);
  const i = 2;
  let history = useHistory();
  const filteredItems = options1
    .slice(0, i)
    .concat(options1.slice(i + 1, options1.length));

  const dropdownOptions = [
    { label: "Coachee", value: "coachee" },
    { label: "Program type", value: "programme_type" },
    { label: "Location", value: "location" },
  ];
  useEffect(() => {
    if (role === "partner" || role === "employee") {
      fetchSpecificAssignments();
    } else {
      fetchAssignments();
    }
  }, [
    searchCategory,
    page,
    pageSize,
    searchText,
    drawerFilterValue,
    filterDataState,
  ]);

  const fetchAssignments = () => {
    let params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      filter_type:
        searchCategory?.value == "all" ? null : searchCategory?.value,
      search_keyword: searchText || "",
      from_date_filter:
        filterDataState[0].startDate == null
          ? ""
          : moment(filterDataState[0].startDate).format("DD-MM-YYYY"),
      to_date_filter:
        filterDataState[0].endDate == null
          ? ""
          : moment(filterDataState[0].endDate).format("DD-MM-YYYY"),
    };
    if (
      drawerFilterValue?.organization &&
      drawerFilterValue?.organization !== "all"
    ) {
      const organisationId =
        organizationList?.find(
          (option) =>
            option.organisation_name?.toLowerCase() ===
            drawerFilterValue?.organization?.toLowerCase()
        )?.id || "";
      params["organisation_id"] = organisationId;
    }
    if (drawerFilterValue?.service && drawerFilterValue?.service !== "all") {
      params["service"] = drawerFilterValue?.service;
    }
    if (
      drawerFilterValue?.service_type &&
      drawerFilterValue?.service_type !== "all"
    ) {
      params["service_type"] = drawerFilterValue?.service_type;
    }
    DataService.getDirectData("/assignments", params)
      .then((res) => {
        if (res?.success) {
          setTotalCount(res?.total_count);
          setAssignmentData(res?.assignments);
          setOrganizationLoader(false);
        }
      })
      .catch(() => {
        setOrganizationLoader(false);
      });
  };
  const fetchSpecificAssignments = () => {
    let params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
    };
    if (organisationId) {
      params["organisation_id"] = organisationId;
    }
    if (searchCategory?.value) {
      params["programme_type"] = searchCategory?.value;
    }
    if (searchText) {
      params["coachee_name"] = searchText;
      params["search_keyword"] = searchText;
    }
    if (drawerFilterValue?.service && drawerFilterValue?.service !== "all") {
      params["service"] = drawerFilterValue?.service;
    }
    if (
      drawerFilterValue?.service_type &&
      drawerFilterValue?.service_type !== "all"
    ) {
      params["service_type"] = drawerFilterValue?.service_type;
    }

    DataService.getDirectData("/assignments/list_org_assignments", params)
      .then((res) => {
        // DataService.getData(params, 'list_all_assignments').then((res) => {
        if (res?.success) {
          setTotalCount(res?.total_count);
          setAssignmentData(res?.assignments);
        }
      })
      .catch(() => {});
  };
  const fetchAssignmentsByStatistics = (value) => {
    let params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      main_filter: value,
      search_keyword: searchText || "",
      from_date_filter:
        filterDataState[0].startDate == null
          ? ""
          : moment(filterDataState[0].startDate).format("DD-MM-YYYY"),
      to_date_filter:
        filterDataState[0].endDate == null
          ? ""
          : moment(filterDataState[0].endDate).format("DD-MM-YYYY"),
    };
    DataService.getDirectData("/assignments", params)
      .then((res) => {
        // DataService.getData(params, 'list_all_assignments').then((res) => {
        if (res?.success) {
          assignmentData.length = 0;
          setTotalCount(res?.total_count);
          setAssignmentData(res?.assignments);
        }
      })
      .catch(() => {});
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentSelection({});
  };
  const handleEditClick = (event, rowData) => {
    rowData.tableData.editing = "update";
    forceUpdate();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const statusMapButtons = {
    Good: "button-positive",
    "Near Due": "button-warning",
    Overdue: "button-negative",
  };

  //   const tableOptions = {
  //       search: true,
  //   };
  const columns = [
    {
      title: "Coachee name",
      headerStyle: {
        width: "30%",
        // textAlign: 'revert',
        color: "#320032",
        paddingLeft: "16px",
      },
      cellStyle: {
        width: "30%",
      },
      field: "coachee_name",
      render: (rowData) => (
        <div className='center' style={{ position: "relative" }}>
          {rowData?.attention_status != "" && (
            <IconButton
              onClick={(event) => {
                setCurrentSelection(rowData);
                setAnchorPopover(event.currentTarget);
                setViewAction("view_more");
              }}
              color='secondary'
            >
              <StatusDot
                variant={
                  rowData?.attention_status == "Green"
                    ? "positive"
                    : rowData?.attention_status == "Red"
                    ? "negative"
                    : "warning"
                }
              />
            </IconButton>
          )}
          <img
            src={rowData?.coachee_image || User}
            alt=''
            style={{
              width: 30,
              height: "30px",
              borderRadius: "50%",
              marginLeft: rowData?.attention_status == "" ? 32 : 0,
            }}
          />
          &nbsp;
          <span style={{ position: "absolute", top: "4px", left: "79px" }}>
            {rowData?.coachee_name || ""}
          </span>
        </div>
      ),
    },
    {
      title: "Coach name",
      field: "coach_name",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
    },
    {
      title: "Follow up date",
      field: "follow_up_date",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
    },
    {
      title: "Overall status",
      field: "status",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
    },
    {
      title: "Final CA received",
      field: "final_CA_received",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
    },
    {
      title: "Client name",
      field: "organisation_name",
      hiddenByColumnsButton: true,
      removable: true,
    },
    {
      title: "Program type",
      field: "programme_type",
      headerStyle: { color: "#320032" },
      hiddenByColumnsButton: true,
      removable: true,
    },
    {
      title: "Total program cost",
      field: "total_programme_cost",
      headerStyle: { color: "#320032" },
    },
    {
      title: "Account manager",
      field: "account_manager",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Number of hours",
      field: "number_of_hours",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Number of sessions",
      field: "number_of_sessions",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "PA/Assistant (Name)",
      field: "pa_name",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "PA/Assistant (contacts) ",
      field: "pa_contact_details",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "LOB Leader",
      field: "lob_leader_name",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Account director",
      field: "account_director",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Name of HRBP",
      field: "HRBP_name",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Line Manager",
      field: "line_manager",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Evaluation form",
      field: "evaluation_form",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Delivery duration",
      field: "delivery_duration",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Client sponsor",
      field: "client_sponsor",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: " Date of next session",
      field: "date_of_next_session",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Date assignment received",
      field: "date_received",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Location",
      field: "location",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Unit",
      field: "unit",
      headerStyle: { color: "#320032" },
      hidden: true,
    },
    {
      title: "Email",
      field: "email",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Title",
      field: "title",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "First session date",
      field: "first_session_date",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Last session date",
      field: "last_session_date",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "CRF received date",
      field: "date_received",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Date of briefing call",
      field: "briefing_call",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Agency",
      field: "agency",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Bank ID ",
      field: "bank_id",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Cost centre",
      field: "cost_centre",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Estimated completion date",
      field: "estimated_completion_date",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Length of program",
      field: "length_of_programme",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "First name",
      field: "coachee_first_name",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Last name",
      field: "coachee_last_name",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Band/Level/Grade",
      field: "level_structure",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Coaches proposed",
      field: "coaches_proposed",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Shortlist feedback",
      headerStyle: { color: "#320032" },
      // emptyValue: '-',
      hidden: true,
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            aria-label='more'
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup='true'
            onClick={(e) => {
              setCurrentSelection({
                assignment_id: rowData.id,
                session_scenario_id: 1,
                title: "Shortlist feedback",
              });
              setIsFeedback(true);
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      ),
    },
    {
      title: "Chemistry/Rapport meeting dates",
      field: "chemistry_meeting_details",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Chemistry/Rapport client feedback",
      headerStyle: { color: "#320032" },
      hidden: true,
      // emptyValue: '-',
      // hidden: true,
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            aria-label='more'
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup='true'
            onClick={(e) => {
              setCurrentSelection({
                assignment_id: rowData.id,
                session_scenario_id: 2,
                title: "Chemistry/Rapport client feedback",
              });
              setIsFeedback(true);
            }}
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      ),
    },
    {
      title: "Hogan certified",
      field: "hogan_certified",
      headerStyle: { color: "#320032" },
      emptyValue: "-",
      hidden: true,
    },
    {
      title: "Actions",
      field: "id",
      headerStyle: {
        width: "10%",
        color: "#320032",
      },
      cellStyle: {
        width: "10%",
      },
      render: (rowData) => (
        <div id={`div-${rowData.id}`}>
          <IconButton
            className={classes.textSecondary}
            aria-label='more'
            aria-controls={`long-menu-${rowData.id}`}
            aria-haspopup='true'
            onClick={(e) => {
              setCurrentSelection(rowData);
              handleClick(e);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const [columsState, setColumsState] = useState(columns);

  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };

  const handleOption = (option) => {
    setDropDownOption(option);
    if (option === "View summary") {
      setAction("view_summary");
      history.push({
        pathname: "assignmentsummary",
        state: { currentAssignment: currentSelection },
      });
    }
    if (option === "View details") {
      history.push({
        pathname: "assignmentoverview",
        state: { currentAssignment: currentSelection },
      });
    } else if (option === "Send on Cal, or Repair") {
      setAction("on_repair");
    } else if (option === "View Cert") {
    } else {
      setAction(option);
    }
  };

  useEffect(() => {
    if (role === "admin" || role === "employee") {
      fetchOrganization();
      fetchService();
    }
  }, []);

  const fetchOrganization = () => {
    DataService.getDirectData(`/organisations`)
      .then((res) => {
        if (res?.success) {
          setOrganizationList(res["organisations"]);
        }
      })
      .catch((err) => {});
  };
  const fetchService = () => {
    DataService.getData({}, "fetch_service")
      .then((res) => {
        if (res?.success) {
          setServiceList(res["services"]);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (filterDataState[0]?.startDate && filterDataState[0]?.endDate) {
      setOrganizationLoader(true);
      fetchAssignments();
      fetchService();
    }
    if (filterDataState[0]?.startDate !== filterDataState[0]?.endDate) {
      setAnchorElPicker(null);
    }
  }, [filterDataState]);

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };

  const openPicker = Boolean(anchorElPicker);
  const id = open ? "simple-popover" : undefined;

  const handleDropDownValue = (event) => {
    let dropValue = event.target.value;
    console.log(dropValue);
    const { name, value } = event?.target;
    setDrawerFilterValue({ [name]: dropValue });
    console.log(dropDownValue, "filter value", drawerFilterValue);
  };

  let drawer = history?.location.state;
  return (
    <div>
      {" "}
      <HomeHeaderMenu />
      <Typography
        style={{
          fontSize: "20px",
          fontWeight: "800",
          color: "#077F83",
          marginLeft: "60px",
          marginTop: "30px",
        }}
      >
        Management Information
      </Typography>
      <Box my={4} mx={8}>
        <div>
          <h4>Service type</h4>
          <Select
            labelId='service'
            defaultValue={dropDownValue?.service || "all"}
            id='service'
            name='service'
            variant='outlined'
            onChange={handleDropDownValue}
            placeholder='Service'
            style={{ width: "250px" }}
            value={drawerFilterValue?.service}
          >
            <MenuItem key='all' value='all'>
              All
            </MenuItem>
            {serviceList?.map((data, index) => {
              return (
                <MenuItem name={data} key={index} value={data}>
                  {data}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <br />
        <br />
        <ProgressBox
          organisationId={organisationId}
          filterStatisticsValue={filterStatisticsValue}
          setFilterStatisticsValue={setFilterStatisticsValue}
          fetchAssignmentsByStatistics={fetchAssignmentsByStatistics}
        />
        <div className={classes.datepickerPopover}>
          <Button
            aria-describedby={id}
            variant='contained'
            onClick={handleClickPicker}
          >
            {filterDataState[0]?.startDate
              ? moment(filterDataState[0]?.startDate).format("Do MMM YYYY")
              : "DD MM YYYY"}{" "}
            -{" "}
            {filterDataState[0]?.endDate
              ? moment(filterDataState[0]?.endDate).format("Do MMM YYYY")
              : "DD MM YYYY"}
          </Button>
          <Popover
            id={id}
            open={openPicker}
            anchorEl={anchorElPicker}
            onClose={handleClosePicker}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
          >
            <DateRange
              className={classes.datePicker}
              editableDateInputs={true}
              onChange={(item) => setFilterDataState([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={filterDataState}
            />
          </Popover>
        </div>
        <div className={classes.miTable}>
          <MaterialTable
            isLoading={organizationLoader}
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant='h2'
                  component='h2'
                  className={classes.subTitle}
                  style={{ color: "#EF7000" }}
                >
                  Assignments
                </Typography>
                <div className={classes.searchCategory}>
                  <SearchByCategory
                    options={dropdownOptions}
                    selectedOption={searchCategory}
                    defaultOption={"All"}
                    setSelectedOption={(event) => {
                      setSearchCategory(event);
                    }}
                    searchText={searchText}
                    handleSearchText={(event) => {
                      setSearchText(event);
                    }}
                  />
                </div>

                {/* <FilterListIcon style={{
                                cursor: "pointer",
                                color: "#EF7000",
                                fontSize: 25,
                                left: "11.5rem", position: "relative",
                            }}
                                onClick={() => {
                                    setFilterModal(true);
                                }} /> */}

                {/* <Button
                                variant="contained"
                                style={{
                                    // backgroundColor: "#EF7000",
                                    color: "#EF7000",
                                    fontSize: 12,
                                    textTransform: "capitalize"
                                }}
                                onClick={() => {
                                    setFilterModal(true);
                                }}
                            ><FilterListIcon />
                            </Button> */}
              </div>
            }
            options={{
              actionsColumnIndex: -1,
              searchFieldAlignment: "right",
              headerStyle: {
                fontWeight: "bold",
              },
              columnsButton: true,
              exportButton: true,
              search: false,
              pageSize: pageSize,
              total: totalCount,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              toolbar: {
                nRowsSelected: "{0} Booking selected",
                searchPlaceholder: "Search Coachee name",
                exportName: <TooltipWrapper text='Download as CSV' />,
                exportAriaLabel: "Download as CSV",
                exportTitle: "Download as CSV",
                showColumnsTitle: <TooltipWrapper text='Show columns' />,
                showColumnsAriaLabel: "Show columns",
              },
              header: {
                actions: "",
              },
            }}
            columns={columsState}
            data={assignmentData}
            totalCount={totalCount}
            page={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            onSearchChange={(search) => {
              setSearchText(search);
            }}
            onChangeColumnHidden={(column, hidden) => {
              setHiddenCol(true);
            }}
            actions={[
              {
                icon: () => <FilterListIcon color='secondary' />,
                tooltip: <TooltipWrapper text='Filter' />,
                isFreeAction: true,
                onClick: (event) => {
                  // setCurrentSelection(rowData);
                  setFilterModal(true);
                  // toggleDrawer(true)
                },
              },
            ]}
          />
          <div className={classes.actionButtons}>
            <div
              className='center'
              style={{ width: "50%", position: "absolute" }}
            >
              <Grid container xs={12}>
                <Grid xs={2}>
                  <StatusDot variant='positive' />
                  &nbsp;&nbsp;
                  <span style={{ fontSize: "14px" }}>On track</span>
                </Grid>
                <Grid xs={2}>
                  <StatusDot variant='warning' />
                  &nbsp;&nbsp;
                  <span style={{ fontSize: "14px" }}>On hold</span>
                </Grid>
                <Grid xs={4} lg={4} md={5}>
                  <StatusDot variant='negative' />
                  &nbsp;&nbsp;
                  <span style={{ fontSize: "14px" }}>
                    Needs immediate attention
                  </span>
                </Grid>
              </Grid>
            </div>
          </div>
          <Menu
            id={`long-menu`}
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "20ch",
              },
            }}
          >
            {currentSelection.calibration_certificate === null
              ? filteredItems.map((option) => (
                  <MenuItem
                    key={option}
                    className={classes.textSecondary}
                    style={{ fontSize: "12px" }}
                    onClick={() => {
                      handleOption(option);
                    }}
                  >
                    {option}
                  </MenuItem>
                ))
              : options1.map((option) => (
                  <MenuItem
                    key={option}
                    className={classes.textSecondary}
                    style={{ fontSize: "12px" }}
                    onClick={() => {
                      handleOption(option);
                    }}
                  >
                    {option}
                  </MenuItem>
                ))}
          </Menu>
          {currentSelection.document === null ? (
            viewAction === "view_more" && (
              <Popover
                anchorOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                style={{ top: "27px", left: "2%" }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "left",
                }}
                open={viewAction === "view_more"}
                anchorEl={anchorPopover}
                onBackdropClick={() => setViewAction(null)}
              >
                <div>
                  <Typography
                    style={{ padding: "5px 0 5px 15px" }}
                    variant='subtitle2'
                    color='secondary'
                  >
                    Credentials
                  </Typography>
                  <List style={{ padding: "15px" }} dense>
                    Username: {currentSelection.username} <br />
                    Password: {currentSelection.password}
                  </List>
                </div>
              </Popover>
            )
          ) : (
            <Popover
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              style={{ top: "45px", left: "2px" }}
              transformOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              open={viewAction === "view_more"}
              anchorEl={anchorPopover}
              onBackdropClick={() => setViewAction(null)}
            >
              <Typography
                style={{ padding: "20px" }}
                variant='subtitle2'
                color='secondary'
              >
                {currentSelection.alert_message}
              </Typography>{" "}
            </Popover>
          )}
        </div>
        {action === "view_summary" && (
          <ViewSummary
            action={action}
            moduleId={data.id}
            data={data}
            handleClose={handleClose}
          />
        )}
        {filterModal && (
          <AssigmentFilterModal
            organizationList={organizationList}
            serviceList={serviceList}
            serviceTypeList={serviceTypeList}
            handleDrawer={setFilterModal}
            filterModal={filterModal}
            selectedValue={drawerFilterValue}
            setDrawerFilterValue={setDrawerFilterValue}
            dropDownValue={dropDownValue}
            setDropDownValue={setDropDownValue}
            role={role}
          />
        )}
        <MIFeedbackModal
          isOpen={isFeedback}
          currentSelection={currentSelection}
          onClose={() => {
            setIsFeedback(false);
          }}
        />
        {drawer && (
          <StatisticsSummaryDrawer
            parentCall={drawer}
            filterStatisticsValue={filterStatisticsValue}
            setFilterStatisticsValue={setFilterStatisticsValue}
            fetchAssignmentsByStatistics={fetchAssignmentsByStatistics}
            flag={drawer}
            organisationId={organisationId}
          />
        )}
      </Box>
    </div>
  );
}

export default FilterMI;
